export default __webpack_public_path__ + "static/media/jewishGuideFront.2227016a.jpg";